export const SET_PAYMENT_RECEIPT = "SET_PAYMENT_RECEIPT";
export const SET_SPECIFIC_PAYMENT_RECEIPT = "SET_SPECIFIC_PAYMENT_RECEIPT";
export const RESET_SPECIFIC_PURCHASES = "RESET_SPECIFIC_PURCHASES";
export const SET_BALANCE = "SET_BALANCE";
export const SET_PENDING_PURCHASES = "SET_PENDING_PURCHASES";
